import React from 'react';

import { createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#29479a'
        },
    },
    typography: {
        fontFamily: 'Nunito',
    },
    overrides: {
        MuiStepIcon: {
            root: {
                color: "#414042",
            },
            active: {
                color: '#fff'
            },
            text: {
                fill: '#fff',
            }
        },
        MuiStepLabel: { 
            label: {
                color: '#414042',
                fontSize: 'large',
            },
            active: {
                color: '#29479a',
                fontSize: 'xx-large',
            },
            completed: {
                color: '#29479a',
                fontSize: 'large',
            },
        },
        MuiStepConnector: {
            lineVertical: {
                minHeight: '50px'
            }
        }

    }
})

function getSteps() {
  return ['Scope', 'Match', 'Build'];
}

export default function VerticalLinearStepper(props) {
    const steps = getSteps();

    return (
    <ThemeProvider theme={theme}>
        <Stepper activeStep={props.stage} orientation="vertical" >
        {steps.map((label, index) => (
            <Step key={label}>
            <StepLabel>{label}</StepLabel>
            </Step>
        ))}
        </Stepper>
    </ThemeProvider>
    );
}
